
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Construction, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

/**
 * Temporary placeholder for the Rewards page
 * Displays a clean "under construction" message while the rewards system is being redesigned
 */
const Rewards = () => {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto p-4 space-y-8 animate-fade-in">
      {/* Header Section */}
      <div className="flex flex-col gap-2">
        <h1 className="text-4xl font-bold bg-gradient-to-r from-primary/80 to-primary/60 bg-clip-text text-transparent">
          Rewards
        </h1>
        <p className="text-muted-foreground">
          Coming soon - we're building something amazing for you!
        </p>
      </div>

      {/* Under Construction Card */}
      <Card className="p-8 bg-gradient-to-r from-primary/5 via-accent/5 to-secondary/5 border border-primary/10 shadow-sm">
        <CardHeader className="text-center pb-6">
          <div className="mx-auto w-16 h-16 bg-gradient-to-br from-primary/10 to-primary/5 rounded-xl flex items-center justify-center mb-4">
            <Construction className="w-8 h-8 text-primary" />
          </div>
          <CardTitle className="text-2xl font-bold">Under Construction</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-muted-foreground max-w-md mx-auto">
            We're redesigning the rewards system to give you a better experience. 
            Check back soon for exciting new features and partner offers!
          </p>
          <Button 
            onClick={() => navigate('/home')} 
            className="bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default Rewards;
